export default "__VITE_ASSET__ffd3f7b3__"